import { createGlobalState } from 'react-hooks-global-state';

const initialState = {
  crestLocation: {
    x: 0,
    y: 0,
    height: 0,
    width: 0,
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
  },
  houseAnimationStarted: false,
  wandAnimationFinished: false,
  firstLoadHouse: false,
};

const { setGlobalState, useGlobalState, getGlobalState } = createGlobalState(initialState);

export const setCrestLocation = (crestLocation) => {
  setGlobalState('crestLocation', crestLocation);
};

export const setHouseAnimationStarted = (houseAnimationStarted) => {
  setGlobalState('houseAnimationStarted', houseAnimationStarted);
};

export const setFirstLoadHouse = (firstLoadHouse) => {
  setGlobalState('firstLoadHouse', firstLoadHouse);
};

export const setWandAnimationFinished = (wandAnimationFinished) => {
  setGlobalState('wandAnimationFinished', wandAnimationFinished);
};

export { useGlobalState, getGlobalState };
